import React from 'react';
import Input from '../../UI/Input';
import Button from '../../UI/Button';

export default function CertificationsForm({ certifications = [], onChange }) {
	const items = certifications || [];

	function add() {
		onChange([...(items || []), { name: '', issuer: '', date: '', expiry: '', credentialId: '', link: '', description: '' }]);
	}
	function remove(i) {
		onChange(items.filter((_, idx) => idx !== i));
	}
	function update(i, key, value) {
		const next = [...items];
		next[i] = { ...next[i], [key]: value };
		onChange(next);
	}

	function verifyUrl(link) {
		try {
			// eslint-disable-next-line no-new
			new URL(link);
			return true;
		} catch {
			return false;
		}
	}

	return (
		<div className="space-y-4">
			{!items.length && <div className="text-sm text-gray-500">No certifications yet.</div>}
			{items.map((c, i) => (
				<div key={i} className="border rounded-md p-4 space-y-3">
					<div className="flex items-center justify-between">
						<div className="text-sm text-gray-500">{c.name}</div>
						<Button variant="ghost" onClick={() => remove(i)}>
							Remove
						</Button>
					</div>
					<div className="grid grid-cols-1 md:grid-cols-2 gap-3">
						<Input name="name" label="Certification Name" value={c.name || ''} onChange={(e) => update(i, 'name', e.target.value)} required />
						<Input name="issuer" label="Issuing Organization" value={c.issuer || ''} onChange={(e) => update(i, 'issuer', e.target.value)} required />
						<Input name="date" label="Issue Date (YYYY-MM-DD)" value={c.date || ''} onChange={(e) => update(i, 'date', e.target.value)} />
						<Input name="expiry" label="Expiry Date (optional)" value={c.expiry || ''} onChange={(e) => update(i, 'expiry', e.target.value)} />
						<Input name="credentialId" label="Credential ID" value={c.credentialId || ''} onChange={(e) => update(i, 'credentialId', e.target.value)} />
						<Input
							name="link"
							label="Credential URL"
							value={c.link || ''}
							onChange={(e) => update(i, 'link', e.target.value)}
							error={c.link && !verifyUrl(c.link) ? 'Invalid URL' : ''}
						/>
						<div className="md:col-span-2">
							<label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
							<textarea
								className="w-full rounded-md border border-gray-300 px-3 py-2"
								rows="3"
								value={c.description || ''}
								onChange={(e) => update(i, 'description', e.target.value)}
							/>
						</div>
					</div>
				</div>
			))}
			<Button variant="ghost" onClick={add}>
				Add Certification
			</Button>
		</div>
	);
}


